<template>
  <div id="goods">
    <div class="top_title fixed">{{ title }}</div>
    <goods-box :info="info" :type="1" :order="{}" :total="total"/>
    <div class="goods_table">
      <div class="th">
        <div class="td" @click="changeEquip">
          装备
          <!-- <img class="rank" src="../../assets/bx/rank.png" alt="" v-if="equipment == ''" />
          <img class="rank" src="../../assets/bx/desc.png" alt="" v-else-if="equipment == 'desc'" />
          <img class="rank" src="../../assets/bx/asc.png" alt="" v-else /> -->
        </div>
        <div class="td" @click="changeNum">
          数量
          <!-- <img class="rank" src="../../assets/bx/rank.png" alt="" v-if="num == ''" />
          <img class="rank" src="../../assets/bx/desc.png" alt="" v-else-if="num == 'desc'" />
          <img class="rank" src="../../assets/bx/asc.png" alt="" v-else /> -->
        </div>
        <div class="td" @click="changePrice">
          价格
          <!-- <img class="rank" src="../../assets/bx/rank.png" alt="" v-if="price == ''" />
          <img class="rank" src="../../assets/bx/desc.png" alt="" v-else-if="price == 'desc'" />
          <img class="rank" src="../../assets/bx/asc.png" alt="" v-else /> -->
        </div>
        <div class="td">操作</div>
      </div>
      <div class="tbody scrollbar">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <van-cell v-for="(item,i) in goodslist" :key="i">
              <div class="td">
                <span class="btStrengCount" v-if="item.btStrengCount&&item.btStrengCount > 0">+{{ item.btStrengCount }}</span>
                <img class="icon" :src="item.icon_url" alt="">
              </div>
              <div class="td">
                {{ item.num }}
              </div>
              <div class="td">
                {{ item.price }}
              </div>
              <div class="td">
                <el-button type="primary" @click="makeOrder(item.id)">购买</el-button>
              </div>
            </van-cell>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        title: "",
        equipment: "desc",
        num: "",
        price: "",
        goodslist: [],
        page: 0,
        pagesize: 10,
        totalpage: 0,
        total: 0,
        loading: false,
        finished: false,
        refreshing: false,
        info: {},
      };
    },
    computed: {
      params() {
        return {
          app_id: this.$store.state.gameId,
          prop_id: this.$route.query.id
        }
      },
      userData() {
        return this.$store.state.userData;
      },
      server_id() {
        return this.$store.state.home_server_id
      },
      isLogin() {
        return this.$store.getters.isLogin;
      },
    },
    mounted() {
      this.getGoodsDetail()
    },
    methods: {
      getGoodsDetail() {
        this.$Ajax('prop/info', this.params, 'get').then(rs => {
          if (rs.code == 200) {
            this.title = rs.data.propInfo.prop_naame
            this.info = rs.data.propInfo
          } 
        })
      },
      changeEquip() {
        if (this.equipment == "desc") {
          this.equipment = "asc";
        } else {
          this.equipment = "desc";
        }
      },
      changeNum() {
        if (this.num == "desc") {
          this.num = "asc";
        } else {
          this.num = "desc";
        }
      },
      changePrice() {
        if (this.price == "desc") {
          this.price = "asc";
        } else {
          this.price = "desc";
        }
      },
      onLoad() {
        if (this.refreshing) {
          this.goodslist = []
          this.refreshing = false;
        }
        this.page++
        this.$Ajax('goods/list-by-prop', {
          page: this.page,
          app_id: this.$store.state.gameId,
          prop_id: this.$route.query.id,
          server_id: this.server_id
        }, 'get').then(rs => {
          if (rs.code == 200) {
            this.total = rs.data.total
            this.goodslist.push(...rs.data.list)
            this.totalpage = rs.data.totalpage
            if (this.page >= this.totalpage) {
              this.finished = true;
            }
          }else {
            this.finished = true;
          }
        }).finally(() => {
          this.loading = false;
        })
      },
      onRefresh() {
        // 清空列表数据
        this.finished = false;
        this.page = 0
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        this.onLoad();
      },

      makeOrder(id) {
        if(this.isLogin) {
          this.$router.push({
            name: 'order',
            query: {
              id
            }
          })
        }else {
          this.$filterPop({
            type: "login",
            direction: "up",
            onSuccess: () => {
              this.$router.push({
                name: 'order',
                query: {
                  id
                }
              })
            },
          });
        }
      }
    },
  };
</script>
<style lang="less" scoped>
  #goods {
    .goods_table {
      background-color: #fff;
      height: calc(var(--vh, 1vh) * 100 - 29rem);
      display: flex;
      flex-direction: column;
      padding-bottom: 0.4rem;

      .th {
        height: 3.2rem;
        display: flex;
        align-items: center;

        .td {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0.6rem 0;
          font-size: 1.4rem;
          &:nth-last-child(1) {
            flex: 1.5;
          }

          .rank {
            width: 1.05rem;
            height: 1.9rem;
            margin-left: 0.8rem;
          }
        }
      }

      .tbody {
        flex: 1;
        margin: 0 1rem;
        border-top: 1px solid #dcdee2;
        overflow-y: auto;

        /deep/.van-cell {
          padding: 0;
          margin-top: .7rem;
          border: none;

          &::after {
            border: none;
          }

          .van-cell__value {
            display: flex;

            .td {
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 1.4rem;
              position: relative;
              &:nth-child(1) {
                flex: 0.7;
              }

              &:nth-child(2) {
                flex: 1.2;
              }

              &:nth-child(3) {
                flex: 1;
              }

              &:nth-last-child(1) {
                flex: 1.5;
                justify-content: flex-end;
              }

              .icon {
                width: 3.25rem;
              }

              .el-button {
                width: 8rem;
                transform: translateX(-0.8rem);
                padding: 0.4rem 0;
                border-radius: 10rem;
                font-size: 1.4rem;
              }
              .btStrengCount {
                position: absolute;
                top: 0;
                left: 0;
                color: #00bb00c5;
                font-size: 1.2rem;
                font-weight: 700;
              }
            }
          }
        }
      }
    }
  }
</style>